import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { useKBar } from 'kbar';
import { useResponsive } from 'ahooks';

const HeaderSearch: React.FC = () => {
  const { query } = useKBar((state) => {
    return state;
  });
  const screen = useResponsive();

  const isMobile = !screen.sm;

  return (
    <Button
      fluid
      basic
      icon
      onClick={query.toggle}
      labelPosition={isMobile ? undefined : 'right'}
      className="app_header_search"
    >
      {!isMobile && <span>What are you looking for?</span>}
      <Icon color="grey" name="search" />
    </Button>
  );
};

export default HeaderSearch;
